import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeliveryAnswersInputs } from "../Account/useAddUpdateAddressForm/DeliveryAnswersInputs";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
var QuestionSectionText;
(function (QuestionSectionText) {
    QuestionSectionText["DEFAULT_TITLE"] = "Questions";
})(QuestionSectionText || (QuestionSectionText = {}));
export const QuestionSection = ({ pickUpQuestions, title, text }) => {
    return (_jsxs(Stack, Object.assign({ spacing: 3 }, { children: [_jsx(Typography, Object.assign({ variant: "h3", color: "primary" }, { children: title !== null && title !== void 0 ? title : QuestionSectionText.DEFAULT_TITLE })), text && _jsx(Typography, { children: text }), _jsx(DeliveryAnswersInputs, { deliveryQuestionsMap: pickUpQuestions, addressId: -1 })] })));
};
